import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  id: "buttonDiv",
  class: "btnSaml"
}

import { ref, Ref } from 'vue'
import { DEFAULT_CONFIG, useConfig } from '@/config/useConfig'
import { until, useAsyncState } from '@vueuse/core'
import { SamlConfig } from '@/types/interfaces'

declare global {
  const saml: any
}

// Provider Settings

export default /*@__PURE__*/_defineComponent({
  __name: 'SamlLoginButton',
  props: ['isSubmitting'],
  emits: ['samlLogin'],
  setup(__props, { emit: __emit }) {

_useCssVars(_ctx => ({
  "e48764c8": (componentState.value.providerPalette.background.main),
  "ff04f374": (componentState.value.providerPalette.color),
  "e4fe0cae": (componentState.value.providerPalette.border),
  "v016f85cd": (`url(${componentState.value.providerLogo})`),
  "v298d7db9": (componentState.value.providerPalette.background.hover)
}))

const componentState: Ref<SamlConfig> = ref(DEFAULT_CONFIG.value.saml)

const props = __props
const { state, isReady } = useAsyncState(
  useConfig(),
  DEFAULT_CONFIG.value
);
(async () => {
  await until(isReady).toBe(true)
  componentState.value = state.value.saml
})()

const emit = __emit

return (_ctx: any,_cache: any) => {
  const _component_lp_button = _resolveComponent("lp-button")!

  return (componentState.value.loginActive === true || componentState.value.loginActive === "true")
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_lp_button, {
          id: "btnSaml",
          class: "saml-button w-100 btn-loading-active",
          loading: props.isSubmitting
        }, {
          default: _withCtx(() => [
            _createTextVNode("Sign In with " + _toDisplayString(componentState.value.providerName), 1)
          ]),
          _: 1
        }, 8, ["loading"])
      ]))
    : _createCommentVNode("", true)
}
}

})